import { Component, OnInit, ViewContainerRef, ViewChildren, Inject, ComponentFactoryResolver, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MfPanelComponent } from '../mf-panel/mf-panel.component';

@Component({
  selector: 'app-mf-popup-panel',
  templateUrl: './mf-popup-panel.component.html',
  styleUrls: ['./mf-popup-panel.component.css']
})
export class MfPopupPanelComponent implements OnInit {
  @ViewChild('formDetails', { read: ViewContainerRef }) public formDetails: ViewContainerRef;
  constructor(@Inject(MAT_DIALOG_DATA) public data: any, private componentFactoryResolver: ComponentFactoryResolver,
    public dialogRef: MatDialogRef<MfPopupPanelComponent>) {
  }

  ngOnInit() {
  }

  public ngAfterViewInit() {

    this.buildForm();
  }

  private buildForm() {
    let target = this.formDetails;
    var component = this.data.component;
    let widgetComponent = this.componentFactoryResolver.resolveComponentFactory(MfPanelComponent);
    let componentRef: any = target.createComponent(widgetComponent);
    let _component: any = (componentRef.instance);
    _component.parent = this;
    _component.formIndex = component.index;
    _component.displayName = component.displayName;
    _component.hideClose = component.hideClose;
    _component.entityOptions = component.entityOptions;
    _component.formOptions = component.formOptions;
    _component.gridOptions = component.gridOptions;
    _component.formOnly = component.formOnly;
    _component.index = 0;
    _component.isDialog = true;
    _component.dialogRef = this.dialogRef;
    _component.extraData = this.data.extraData;
    _component.customEntityId = this.data.customEntityId
    if (_component.load) _component.load();

  }
}
